document.addEventListener('DOMContentLoaded', function () {
  const soundbarProducts = [
    {
      title: 'SOUNDBARHYLDE TIL A2 HIGH/LARGE, 95 CM',
      type: 'high-large',
      size: '95',
      url: '/products/soundbar-hylde-til-a2-h-l-95-cm'
    },
    {
      title: 'SOUNDBARHYLDE TIL A2 LOW, 95 CM',
      type: 'low',
      size: '95',
      url: '/products/soundbar-hylde-til-a2-low-95-cm'
    },
    {
      title: 'SOUNDBARHYLDE TIL A2 HIGH/LARGE, 60 CM',
      type: 'high-large',
      size: '60',
      url: '/products/soundbar-hylde-til-a2-h-l-60-cm'
    },
    {
      title: 'SOUNDBARHYLDE TIL A2 LOW, 60 CM',
      type: 'low',
      size: '60',
      url: '/products/soundbar-hylde-til-a2-low-60-cm'
    }
  ];

  function showSoundbarPopup(product) {
    const popup = document.getElementById('soundbar-popup');

    if (!popup) return;

    const title = popup.querySelector('.soundbar-popup__title');
    const text = popup.querySelector('.soundbar-popup__text');
    const otherModel = popup.querySelector('.soundbar-popup__other-model');

    if (title) {
      title.textContent = 'DU HAR LAGT EN SOUNDBARHYLDE I KURVEN';
    }

    if (text) {
      if (product.type === 'high-large') {
        text.innerHTML =
          'Denne soundbarhylde passer til <strong>A2 High og A2 Large</strong>.';
      } else {
        text.innerHTML =
          'Denne soundbarhylde passer til <strong>A2 Low</strong>.';
      }
    }

    if (otherModel) {
      const otherProduct = soundbarProducts.find(
        item =>
          item.size === product.size &&
          item.type !== product.type
      );

      if (otherProduct) {
        otherModel.href = otherProduct.url;
        otherModel.style.display = 'inline-block';

        if (otherProduct.type === 'high-large') {
  otherModel.textContent = 'SE HYLDE TIL A2 HIGH/LARGE';
} else {
  otherModel.textContent = 'SE HYLDE TIL A2 LOW';
}
      }
    }

    popup.style.display = 'block';
  }

  function checkProductAndShowPopup(productId) {
    fetch('/products.json?limit=250')
      .then(response => response.json())
      .then(data => {
        data.products.forEach(product => {
          const variantFound = product.variants.some(
            variant => String(variant.id) === String(productId)
          );

          if (!variantFound) return;

          const soundbarProduct = soundbarProducts.find(
            item =>
              product.title.trim().toLowerCase() ===
              item.title.toLowerCase()
          );

          if (soundbarProduct) {
            showSoundbarPopup(soundbarProduct);
          }
        });
      })
      .catch(error => {
        console.error('Soundbar popup error:', error);
      });
  }

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('form[action*="/cart/add"]');

    if (!form) return;

    const variantInput = form.querySelector('[name="id"]');

    if (!variantInput) return;

    checkProductAndShowPopup(variantInput.value);
  });

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('.soundbar-popup__close') ||
      event.target.closest('.soundbar-popup__overlay') ||
      event.target.closest('.soundbar-popup__continue')
    ) {
      const popup = document.getElementById('soundbar-popup');

      if (popup) {
        popup.style.display = 'none';
      }
    }
  });
});